import { Record } from "immutable";

const defaults = {
    id: "",
    name: "",
    page_type: "",
    published: false,
    slug: "",
    type: "page",
    about: "",
    brand_id: "",
    buyer_landing_page_layout_id: undefined,
    company_overview: "",
    description: "",
    display_subtext: "",
    picture: {},
    cover_pictures: [],
    legacy_linesheet_id: "",
    legacy_brand_price_points: [],
    brand_categories: [],
    social_links: [],
    created_at_ms: "",
    modified_at_ms: "",
    instagram_enabled: false,
    instagram_user: undefined,
};

class BrandProfile extends Record(defaults) {}

export default BrandProfile;
